$(function(){
    
    $(".video-pop-wrapper").on("click", ".close-js, .tw-mask", function(e) {
        $(this).closest(".video-pop-wrapper").fadeOut();
        // 暂停视频（包括iframe）
        var videoElement = $(this).closest(".video-pop-wrapper").find("video")[0];
        if (videoElement) {
          videoElement.pause();
        }
        var iframeElement = $(this).closest(".video-pop-wrapper").find("iframe")[0];
        if (iframeElement) {
          var iframeSrc = iframeElement.src;
          iframeElement.src = iframeSrc; // 重新设置iframe的src将其暂停
        }
    });

    $(document).on('click', '.video-pop-js', function(e) {
        const popId = $(this).attr('pop-id');
    
        const videoWrap1 = $('.video-pop-wrapper');

        const videoWrap = $('.video-pop-wrapper[pop-id="' + popId + '"]');
        if (!videoWrap.length) {
            console.warn('未找到对应的 video-pop-wrapper，pop-id:', popId);
            return;
        }
        e.preventDefault();
        videoWrap.fadeIn();
        // 播放视频
        const videoElement = videoWrap.find('video')[0];
        if (videoElement && videoElement.paused) {
          videoElement.play();
        }
    
        const iframeElement = videoWrap.find('iframe')[0];
    
        if (iframeElement) {
          const iframeSrc = iframeElement.src;
          iframeElement.src = iframeSrc; // 重新设置iframe的src将其播放
        }
    });
    


})

